__turbopack_context__.v({
  "backArrowIcon": "lPillq_backArrowIcon",
  "button": "lPillq_button",
  "hideLabel": "lPillq_hideLabel",
  "label": "lPillq_label",
});
